import { render, staticRenderFns } from "./TemplateLogin.vue?vue&type=template&id=c74ef84a&scoped=true"
import script from "./TemplateLogin.vue?vue&type=script&lang=js"
export * from "./TemplateLogin.vue?vue&type=script&lang=js"
import style0 from "./TemplateLogin.vue?vue&type=style&index=0&id=c74ef84a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74ef84a",
  null
  
)

export default component.exports